'use client'
import { styled } from '../config'

function Svg(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M10.2888 3.8602L1.8188 18.0002C1.64417 18.3026 1.55177 18.6455 1.55079 18.9947C1.54981 19.3439 1.64029 19.6873 1.81323 19.9907C1.98616 20.2941 2.23553 20.547 2.53651 20.7241C2.83749 20.9012 3.1796 20.9964 3.5288 21.0002H20.4688C20.818 20.9964 21.1601 20.9012 21.4611 20.7241C21.7621 20.547 22.0114 20.2941 22.1844 19.9907C22.3573 19.6873 22.4478 19.3439 22.4468 18.9947C22.4458 18.6455 22.3534 18.3026 22.1788 18.0002L13.7088 3.8602C13.5305 3.56631 13.2795 3.32332 12.98 3.15469C12.6805 2.98605 12.3425 2.89746 11.9988 2.89746C11.6551 2.89746 11.3171 2.98605 11.0176 3.15469C10.7181 3.32332 10.4671 3.56631 10.2888 3.8602V3.8602Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V13"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17H12.01"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Warning = styled(Svg, {
  stroke: '#6F6F74',
})
